import bridge from '@/config/JSbridge'
import bwmodel from '@/config/bwmodel'
import moment from 'moment'
import KJUR from 'KJUR'
import store from './index'
let nextTodoId = 0
export const addTodo = text => ({
  type: 'ADD_TODO',
  id: nextTodoId++,
  text
})
// user相关的actions
export const setUserInfo = text => {
  return (dispatch) => new Promise(resolve => {
    
    if (bwmodel.app === 'storm') {
      bridge.callHandler('nativeEvent', {
        event: 'userInfo',
        params: {}
      }, res => {
        let result = JSON.parse(res)
        if (result.code === 0) {
          if (result.params) {
            let info = {
              userId: result.params.userId,
              userName: result.params.userName,
              avatar: result.params.avatarUrl,
              authLevel: result.params.authLevel,
              autoLoadResource: typeof(result.params.autoLoadResource) !== 'undefined' ? result.params.autoLoadResource : true,
              accessToken: result.params.accessToken || '',
              deviceNo: result.params.deviceNo || '',
              deviceType: encodeURIComponent(result.params.deviceType) || '',
              systemVersion: result.params.systemVersion || '',
            }
            if (result.params.accessToken) {
              let jws = new KJUR.jws.JWS()
              jws.parseJWS(result.params.accessToken)
              let accessObj = KJUR.jws.JWS.readSafeJSONString(jws.parsedJWS.payloadS)
              let accessTokenExp = moment(accessObj.expirationWithTimeZone).subtract(5, 'minute')
              info.expires = accessTokenExp || ''
            }
            if (result.params.userType && result.params.userType !== 0) {
              info.userType = result.params.userType
            }
            dispatch(getUserInfo(info))
            resolve()
          }
        }
        resolve()
      })
    } else {
      resolve()
    }
  })
}
// app 相关的actions


export const getUserInfo = user => ( {
  type: 'SET_USER_INFO',
  user
})
export const getAppInfo = data => ( {
  type: 'SET_APP_INFO',
  data
})

// 刷新token
export const refreshToken = ()=>{
  return dispatch => {
    dispatch(setRefreshstatus(true))
    return new Promise(resolve => {
      bridge.callHandler('nativeEvent', {
        event: 'refreshAccessToken',
        params: {}
      }, res => {
        let result = JSON.parse(res)
        if (result.code === 0) {
          dispatch(setAccesstoken(result.params.accessToken ))
          if (result.params.accessToken) {
            let jws = new KJUR.jws.JWS()
            jws.parseJWS(result.params.accessToken)
            let accessObj = KJUR.jws.JWS.readSafeJSONString(jws.parsedJWS.payloadS)
            let accessTokenExp = moment(accessObj.expirationWithTimeZone).subtract(5, 'minute')
            dispatch(setExpires(accessTokenExp))
          } else {
            dispatch(setExpires(''))
          }
        }
        dispatch(setRefreshstatus(false))
        resolve()
      })
    })
  }
} 
export const setRefreshstatus = status =>({
  type: 'SET_REFRESHSTATUS',
  status:status
})
export const setAccesstoken = accessToken =>({
  type: 'SET_ACCESSTOKEN',
  accessToken: accessToken
})
export const setExpires = expires =>({
  type: 'SET_EXPIRES',
  expires: expires
})
export const changeRefreshToken = () =>{
  return () =>{
    return new Promise(resolve => {
      let lunxun = setInterval(() => {
        if (!store.getState().user.refreshStatus) {
          clearInterval(lunxun)
          resolve()
        }
      }, 50)
    })
  }
}

export const setTheme = (data) =>({
	type: 'SET_THEME',
	data: data
})
